import { Component } from "react";
import { notifyBugsnag } from "@/utils/bugsnag/bugsnagConsent";
import ErrorFallback from "./ErrorFallback";

export default class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		notifyBugsnag(error, (event) => {
			event.addMetadata("react", errorInfo);
		});
	}

	render() {
		if (this.state.hasError) {
			return <ErrorFallback />;
		}

		return this.props.children;
	}
}
